export default __webpack_public_path__ + "static/contributors-banner-bf22e68283d5f2da74d006fe2a161cbd.png";